import axios from 'axios';

export interface BulkInvoiceCreateFilter {
  clientId: string | null;
  matterIds: string[] | null;
  matterId: string | null;
  startDate?: string;
  endDate?: string;
  include?: Record<string, boolean>;
  timeOffset: number;
  checkboxesChecked: string;
  expenseRange?: { startDate: string; endDate: string };
}

export interface BulkInvoiceCreateItemResult {
  clientId: string | null;
  matterId: string | null;
  success?: boolean;
  timeSheetId?: string;
  invoiceNumber?: string;
  error?: string;
}

export interface BulkInvoiceCreateResult {
  results: BulkInvoiceCreateItemResult[];
  succeededCount: number;
  failedCount: number;
}

export default {
  // Goes through axios directly rather than the legacy leanLawApi wrapper (new code's
  // convention; leanLawApi.createInvoiceBulk stays as the AngularJS controller's own call).
  // timeoutMs is a per-request abort, not a general axios default.
  async createBulk(
    filters: BulkInvoiceCreateFilter[],
    batchKey: string,
    method: string,
    timeoutMs: number,
  ): Promise<BulkInvoiceCreateResult> {
    const { data } = await axios.post<BulkInvoiceCreateResult>(
      '/invoices/bulk',
      { method, filters, batchKey },
      { timeout: timeoutMs },
    );
    return data;
  },
};
